import { render, staticRenderFns } from "./RsaPazienteStoricoStatiListPage.vue?vue&type=template&id=6be0bbed"
import script from "./RsaPazienteStoricoStatiListPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteStoricoStatiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports